<template>
    <Modal
        v-model="showModel"
        width="1000"
        :mask-closable="false">
        <div class="wrapper">
            <vue-cropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :info="true"
            :fixedBox="option.fixedBox"
            :autoCrop="option.autoCrop"
            :autoCropWidth="autoCropWidth"
            :autoCropHeight="autoCropHeight"
            @realTime="realTime"
            ></vue-cropper>
        </div>
        <p class="p-text">提示：支持鼠标进行移动和缩放</p>
        <div class="test-button">
            <label class="btn" for="uploads">换图</label>
            <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event, 1)">
            <button @click="changeScale(1)" class="btn">+</button>
            <button @click="changeScale(-1)" class="btn">-</button>
            <button @click="rotateLeft" class="btn"><i class="fa fa-undo" aria-hidden="true"></i></button>
            <button @click="rotateRight" class="btn"><i class="fa fa-repeat" aria-hidden="true"></i></button>
        </div>
        <p class="p-text" v-show="previews.w > 5">预览：</p>
        <div class="show-preview" :style="{'width': previews.w + 'px', 'height': previews.h + 'px',  'overflow': 'hidden', 'margin': '5px'}">
            <div :style="previews.div">
                <img :src="previews.url" :style="previews.img">
            </div>
        </div>
        <div slot="footer">
            <Button type="text" @click="showModel=false">取消</Button>
            <Button type="primary" @click="finish">确定</Button>
        </div>
    </Modal>
</template>

<script>
import VueCropper from 'vue-cropper';
import Api from '@/resource' //接口url配置文件
import Config from "@/config.js";
export default {
    components:{
        VueCropper
    },
    props: {
        autoCropWidth:{
            type: Number,
            default: 100
        },
        autoCropHeight: {
            type: Number,
            default: 100
        }
    },
    data() {
        return {
            uploadUrl: Config.uploadUrl,//上传地址
            previews: {},//预览
            option: {//属性
                img: '',
                size: 1,
                autoCrop: true,
                fixedBox: true
            },
            showModel: false,
            fileName: '',//文件名
            file:{}//服务器文件
        } 
    },
    methods: {
        /**
         * 实时预览函数
         * @param {object} data 图片相关数据
         */
        realTime (data) {
            this.previews = data
        },
        /**
         * 上传
         * @param {object} e $event
         * @param {int} num 
         */
        uploadImg (e, num) {
            //上传图片
            // this.option.img
            var file = e.target.files[0]
            this.fileName = file.name;
            if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
                 alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
                 return false
             }
            var reader = new FileReader()
            reader.onload = (e) => {
                let data
                if (typeof e.target.result === 'object') {
                    // 把Array Buffer转化为blob 如果是base64不需要
                    data = window.URL.createObjectURL(new Blob([e.target.result]))
                } else {
                    data = e.target.result
                }
                if (num === 1) {
                    this.option.img = data
                } else if (num === 2) {
                    this.example2.img = data
                }
            }
            // 转化为base64
            // reader.readAsDataURL(file)
            // 转化为blob
            reader.readAsArrayBuffer(file)
        },
        //左旋转
        rotateLeft(){
            this.$refs.cropper.rotateLeft();
        },
        //右旋转
        rotateRight(){
            this.$refs.cropper.rotateRight();
        },
        /**
         * 放大缩小
         * @param {int} num 数值
         */
        changeScale(num){
            this.$refs.cropper.changeScale(num);
        },
        openUploadModel(){
            this.showModel = true;
            this.$el.querySelector('[type=file]').click();
        },
        //上传图片（点击上传按钮）
        finish(type) { 
            let _self = this;
            let formData = new FormData();
            _self.$refs.cropper.getCropBlob((data) => {
                let img = window.URL.createObjectURL(data)
                _self.model = true; 
                _self.modelSrc = img; 
                formData.append("type", 2);
                formData.append("file[]", data, _self.fileName);
                Api.post(_self.uploadUrl, formData, {contentType: false, processData: false, headers:{'Content-Type': 'application/x-www-form-urlencoded'}})
                .then((response)=>{
                    if(response.code == 200){
                        _self.file = response.data[0];
                        _self.showModel = false;
                        _self.$emit('returnFile', _self.file);
                    }else{
                        _self.$Message.error('上传失败，错误信息：'+response.msg);
                    }
                })
            })
        },

    },
    mounted() {
        
    }
};
</script>


<style scoped>
@import './cropper.less';
</style>


// WEBPACK FOOTER //
// src/components/imgCropper/Cropper.vue